const DATA_ROUTE_PREFIX = '/data/atomyx_manage';

const ASSET = `${DATA_ROUTE_PREFIX}/file/`;
const ASSETS = `${DATA_ROUTE_PREFIX}/files/`;

const PLUG_IN_FILE = `${DATA_ROUTE_PREFIX}/plug_ins/file/`;
const PLUG_IN_ICON = `${DATA_ROUTE_PREFIX}/plug_ins/icon/`;

const PLUG_IN_STORE_ICON = `${DATA_ROUTE_PREFIX}/plug_in_store/icon/`;
const PLUG_IN_STORE_TRANSLATION = `${DATA_ROUTE_PREFIX}/plug_in_store/translation/`;

export const getPlugInIconPath = (name: string, version: string, isInstalled?: boolean) => (
  `${isInstalled ? PLUG_IN_ICON : PLUG_IN_STORE_ICON}${name}/${version}`
);

export const getPlugInTranslationPath = (name: string, version: string, lang: string) => (
  `${PLUG_IN_STORE_TRANSLATION}${name}/${version}/${lang}`
);

export const getPlugInFilePath = (
  pluginName: string,
  pluginVersion: string,
  folderName: string,
  filename: string,
) => {
  return `${PLUG_IN_FILE}${pluginName}/${pluginVersion}/${folderName}/${filename}`;
};

export const uploadFile = () => {
  return `${ASSET}`;
};

export const getAllAssetStatus = (
  entityType: string,
  entityId: string,
  propertyId: string,
) => {
  return `${ASSETS}${entityType}/${entityId}/${propertyId}/status`;
};

export const getAssetStatus = (
  entityType: string,
  entityId: string,
  propertyId: string,
  actionType: string,
) => {
  return `${ASSET}${entityType}/${entityId}/${propertyId}/status/${actionType}`;
};

export const createAsset = (
  entityType: string,
  entityId: string,
  propertyId: string,
) => {
  return `${ASSET}${entityType}/${entityId}/${propertyId}/create`;
};

export const lockAsset = (
  entityType: string,
  entityId: string,
  propertyId: string,
  force?: boolean,
) => {
  return `${ASSET}${entityType}/${entityId}/${propertyId}/lock${force ? '?force=true' : ''}`;
};

export const lockUploadAsset = (
  entityType: string,
  entityId: string,
  propertyId: string,
) => {
  return `${ASSET}${entityType}/${entityId}/${propertyId}/lock_upload`;
};

export const unlockAsset = (
  entityType: string,
  entityId: string,
  propertyId: string,
  force?: boolean,
) => {
  return `${ASSET}${entityType}/${entityId}/${propertyId}/unlock${force ? '?force=true' : ''}`;
};

export const infoAsset = (
  entityType: string,
  entityId: string,
  propertyId: string,
) => {
  return `${ASSET}${entityType}/${entityId}/${propertyId}/info`;
};

export const getAssetFilePath = (
  entityType: string,
  entityId: string,
  propertyId: string,
) => {
  return `${ASSET}${entityType}/${entityId}/${propertyId}`;
};
